import { Outlet } from "react-router-dom";
import MarginCalculatorLayout from "../../domain/margincalculator/layout/MarginCalculatorLayout";
import MarginCalculatorSideTabs from "../../domain/margincalculator/layout/MarginCalculatorSideTabs";
import { useIsModuleEnabled } from "../../domain/platform_core/feature_flags/services/FeatureFlagService";
import ModuleLockedLayout from "../../domain/platform_core/funnel/components/ModuleLockedLayout";
import ServerUnavailable from "../../domain/platform_core/shell/components/ServerUnavailable";

export default function MarginCalculatorPage() {
  const { isEnabled, isLoading, isError, isRetrying, retry } =
    useIsModuleEnabled("calculator");

  // Keine Modul-Inhalte rendern, solange der Freischaltungsstatus nicht feststeht.
  if (isLoading) return null;
  if (isError) return <ServerUnavailable onRetry={retry} isRetrying={isRetrying} />;

  if (!isEnabled) {
    return (
      <ModuleLockedLayout
        moduleId="calculator"
        moduleName="Margenkalkulator"
        fallbackDescription="Margen kalkulieren und optimieren"
      />
    );
  }

  return (
    <MarginCalculatorLayout sidebar={<MarginCalculatorSideTabs />}>
      <Outlet />
    </MarginCalculatorLayout>
  );
}
